import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import LoginPage from "../pages/login/page";
import LandingPage from "../pages/landing/page";
import ProtectedLayout from "../components/feature/ProtectedPage";
import ResumenPage from "../pages/resumen/page";
import ConvivenciaPage from "../pages/convivencia/page";
import OrientacionPage from "../pages/orientacion/page";
import PsicologoPage from "../pages/psicologo/page";
import DirectorPage from "../pages/director/page";
import DocentePage from "../pages/docente/page";
import DocenteSolicitudesPage from "../pages/docente/solicitudes/page";
import DocenteSolicitudPage from "../pages/docente/solicitud/page";
import DocenteHistorialPage from "../pages/docente/historial/page";
import DocenteDevolucionesPage from "../pages/docente/devoluciones/page";
import ProfesorJefePage from "../pages/profesor_jefe/page";
import InspectorPage from "../pages/inspector/page";
import StubPage from "../pages/shared/stubs";
import JudicialPage from "../pages/judicial/page";
import JudicialRequerimientosPage from "../pages/judicial/requerimientos/page";
import JudicialNuevoPage from "../pages/judicial/nuevo/page";
import JudicialRequerimientoDetailPage from "../pages/judicial/requerimiento/page";
import JudicialInformesPage from "../pages/judicial/informes/page";

// ── Reused pages ──
import AlertasPage from "../pages/dashboard/alertas/page";
import CalendarioPage from "../pages/dashboard/calendario/page";
import ConsultaPage from "../pages/consulta/page";
import ProtocolosPage from "../pages/consulta/protocolos/page";
import ResumenGeneradorPage from "../pages/consulta/resumen/page";
import ReglamentoPage from "../pages/reglamento/page";
import NormativaPage from "../pages/normativa/page";
import CasosPage from "../pages/casos/page";
import CasoNuevoPage from "../pages/casos/nuevo/page";
import CasoDetallePage from "../pages/casos/detalle/page";
import CasosKanbanPage from "../pages/casos/kanban/page";
import CasosJudicializadosPage from "../pages/casos/judicializados/page";
import EstudiantesPage from "../pages/estudiantes/page";
import EstudianteDetallePage from "../pages/estudiantes/detalle/page";
import OrientacionInformesPage from "../pages/orientacion/informes/page";
import OrientacionInformesEnviadosPage from "../pages/orientacion/informes/enviados/page";
import OrientacionInformesGenerarPage from "../pages/orientacion/informes/generar/page";
import OrientacionInsumosPage from "../pages/orientacion/insumos/page";
import IntervencionNuevaPage from "../pages/intervenciones/nueva/page";
import IntervencionEntrevistasPage from "../pages/intervenciones/entrevistas/page";
import IntervencionDerivacionesPage from "../pages/intervenciones/derivaciones/page";
import IntervencionSeguimientosPage from "../pages/intervenciones/seguimientos/page";
import IntervencionEvidenciasPage from "../pages/intervenciones/evidencias/page";
import AdminUsuariosPage from "../pages/admin/usuarios/page";
import AdminDocumentosPage from "../pages/admin/documentos/page";
import AdminReportesPage from "../pages/admin/reportes/page";
import SaasTenantsPage from "../pages/saas/tenants/page";
import SaasNormativaPage from "../pages/saas/normativa/page";
import AdminPage from "../pages/admin/page";

// ── New Page Imports ──
import ResumenIndicadoresPage from "../pages/resumen/indicadores/page";
import ResumenActividadPage from "../pages/resumen/actividad/page";
import ConvivenciaMedidasPage from "../pages/convivencia/medidas/page";
import ConvivenciaInformesPage from "../pages/convivencia/informes/page";
import OrientacionInsumosRecibidosPage from "../pages/orientacion/insumos-recibidos/page";
import PsicologoCasosPage from "../pages/psicologo/casos/page";
import PsicologoIntervencionesPage from "../pages/psicologo/intervenciones/page";
import PsicologoSeguimientoPage from "../pages/psicologo/seguimiento/page";
import PsicologoDerivacionesInternasPage from "../pages/psicologo/derivaciones-internas/page";
import PsicologoDerivacionesExternasPage from "../pages/psicologo/derivaciones-externas/page";
import PsicologoInformesPage from "../pages/psicologo/informes/page";
import PsicologoConfidencialPage from "../pages/psicologo/confidencial/page";
import AdminConfiguracionPage from "../pages/admin/configuracion/page";
import AdminHistorialPage from "../pages/admin/historial/page";
import AdminPermisosPage from "../pages/admin/permisos/page";
import DirectorIndicadoresPage from "../pages/director/indicadores/page";
import DirectorActividadPage from "../pages/director/actividad/page";
import DirectorReporteConvivenciaPage from "../pages/director/reportes/convivencia/page";
import DirectorReporteOrientacionPage from "../pages/director/reportes/orientacion/page";
import DirectorReportePsicologiaPage from "../pages/director/reportes/psicologia/page";
import DirectorReporteJudicializadosPage from "../pages/director/reportes/judicializados/page";
import DirectorReporteDesempenoPage from "../pages/director/reportes/desempeno/page";
import DirectorReporteConsolidadoPage from "../pages/director/reportes/consolidado/page";
import ProfesorJefeSolicitudesPage from "../pages/profesor-jefe/solicitudes/page";
import ProfesorJefeFormulariosPage from "../pages/profesor-jefe/formularios/page";
import ProfesorJefeHistorialPage from "../pages/profesor-jefe/historial/page";
import ProfesorJefeEstudiantesActivosPage from "../pages/profesor-jefe/estudiantes-activos/page";
import ConsultaHistorialPage from "../pages/consulta/historial/page";

const routes: RouteObject[] = [
  // ── Public routes ──
  { path: "/", element: <LandingPage /> },
  { path: "/login", element: <LoginPage /> },

  // ── Protected routes — all wrapped in DashboardLayout with sidebar ──
  {
    element: <ProtectedLayout />,
    children: [
      // ═══════════════════════════════════════════
      // DIRECTOR (Resumen Ejecutivo)
      // ═══════════════════════════════════════════
      { path: "/director", element: <DirectorPage /> },
      { path: "/director/indicadores", element: <DirectorIndicadoresPage /> },
      { path: "/director/alertas", element: <AlertasPage /> },
      { path: "/director/actividad", element: <DirectorActividadPage /> },
      { path: "/director/prioritarios", element: <ResumenPage /> }, // Direct mapping
      { path: "/director/reportes/convivencia", element: <DirectorReporteConvivenciaPage /> },
      { path: "/director/reportes/orientacion", element: <DirectorReporteOrientacionPage /> },
      { path: "/director/reportes/psicologia", element: <DirectorReportePsicologiaPage /> },
      { path: "/director/reportes/judicializados", element: <DirectorReporteJudicializadosPage /> },
      { path: "/director/reportes/desempeno", element: <DirectorReporteDesempenoPage /> },
      { path: "/director/reportes/consolidado", element: <DirectorReporteConsolidadoPage /> },

      // ═══════════════════════════════════════════
      // 1. RESUMEN
      // ═══════════════════════════════════════════
      { path: "/resumen", element: <ResumenPage /> },
      { path: "/resumen/indicadores", element: <ResumenIndicadoresPage /> },
      { path: "/resumen/alertas", element: <AlertasPage /> },
      { path: "/resumen/actividad", element: <ResumenActividadPage /> },
      { path: "/resumen/calendario", element: <CalendarioPage /> },
      { path: "/resumen/prioritarios", element: <ResumenPage /> }, // Direct mapping

      // ═══════════════════════════════════════════
      // 2. GESTIÓN DE CONVIVENCIA ESCOLAR
      // ═══════════════════════════════════════════
      { path: "/convivencia", element: <ConvivenciaPage /> },
      { path: "/convivencia/casos", element: <CasosPage /> },
      { path: "/convivencia/casos/nuevo", element: <CasoNuevoPage /> },
      { path: "/convivencia/calendario", element: <CalendarioPage /> },
      { path: "/convivencia/alertas", element: <AlertasPage /> },
      { path: "/convivencia/seguimientos", element: <IntervencionSeguimientosPage /> },
      { path: "/convivencia/entrevistas", element: <IntervencionEntrevistasPage /> },
      { path: "/convivencia/medidas", element: <ConvivenciaMedidasPage /> },
      { path: "/convivencia/derivaciones", element: <IntervencionDerivacionesPage /> },
      { path: "/convivencia/expedientes", element: <EstudiantesPage /> },
      { path: "/convivencia/informes", element: <ConvivenciaInformesPage /> },

      // ═══════════════════════════════════════════
      // 3. GESTIÓN DE ORIENTACIÓN
      // ═══════════════════════════════════════════
      { path: "/orientacion", element: <OrientacionPage /> },
      { path: "/orientacion/casos", element: <CasosPage /> },
      { path: "/orientacion/judicializados", element: <CasosJudicializadosPage /> },
      { path: "/orientacion/informes", element: <OrientacionInformesPage /> },
      { path: "/orientacion/insumos", element: <OrientacionInsumosPage /> },
      { path: "/orientacion/insumos-recibidos", element: <OrientacionInsumosRecibidosPage /> },
      { path: "/orientacion/calendario", element: <CalendarioPage /> },
      { path: "/orientacion/alertas", element: <AlertasPage /> },
      { path: "/orientacion/seguimientos", element: <IntervencionSeguimientosPage /> },
      { path: "/orientacion/entrevistas", element: <IntervencionEntrevistasPage /> },
      { path: "/orientacion/expedientes", element: <EstudiantesPage /> },
      { path: "/orientacion/informes-generados", element: <OrientacionInformesEnviadosPage /> },

      // ═══════════════════════════════════════════
      // REQUERIMIENTOS JUDICIALES
      // ═══════════════════════════════════════════
      { path: "/judicial", element: <JudicialPage /> },
      { path: "/judicial/requerimientos", element: <JudicialRequerimientosPage /> },
      { path: "/judicial/nuevo", element: <JudicialNuevoPage /> },
      { path: "/judicial/requerimiento/:id", element: <JudicialRequerimientoDetailPage /> },
      { path: "/judicial/informes", element: <JudicialInformesPage /> },

      // ═══════════════════════════════════════════
      // 4. GESTIÓN PSICÓLOGO
      // ═══════════════════════════════════════════
      { path: "/psicologo", element: <PsicologoPage /> },
      { path: "/psicologo/casos", element: <PsicologoCasosPage /> },
      { path: "/psicologo/intervenciones", element: <PsicologoIntervencionesPage /> },
      { path: "/psicologo/seguimiento", element: <PsicologoSeguimientoPage /> },
      { path: "/psicologo/entrevistas", element: <IntervencionEntrevistasPage /> },
      { path: "/psicologo/derivaciones-internas", element: <PsicologoDerivacionesInternasPage /> },
      { path: "/psicologo/derivaciones-externas", element: <PsicologoDerivacionesExternasPage /> },
      { path: "/psicologo/alertas", element: <AlertasPage /> },
      { path: "/psicologo/calendario", element: <CalendarioPage /> },
      { path: "/psicologo/expedientes", element: <EstudiantesPage /> },
      { path: "/psicologo/informes", element: <PsicologoInformesPage /> },
      { path: "/psicologo/confidencial", element: <PsicologoConfidencialPage /> },

      // ═══════════════════════════════════════════
      // 5. INSPECTOR
      // ═══════════════════════════════════════════
      { path: "/inspector", element: <InspectorPage /> },

      // ═══════════════════════════════════════════
      // 6. PROFESOR JEFE
      // ═══════════════════════════════════════════
      { path: "/profesor-jefe", element: <ProfesorJefePage /> },
      { path: "/profesor-jefe/alertas", element: <AlertasPage /> },
      { path: "/profesor-jefe/solicitudes", element: <ProfesorJefeSolicitudesPage /> },
      { path: "/profesor-jefe/formularios", element: <ProfesorJefeFormulariosPage /> },
      { path: "/profesor-jefe/historial", element: <ProfesorJefeHistorialPage /> },
      { path: "/profesor-jefe/estudiantes-activos", element: <ProfesorJefeEstudiantesActivosPage /> },

      // ═══════════════════════════════════════════
      // 7. DOCENTE
      // ═══════════════════════════════════════════
      { path: "/docente", element: <DocentePage /> },
      { path: "/docente/solicitudes", element: <DocenteSolicitudesPage /> },
      { path: "/docente/solicitudes/:id", element: <DocenteSolicitudPage /> },
      { path: "/docente/solicitud/:id", element: <DocenteSolicitudPage /> },
      { path: "/docente/formularios", element: <DocenteSolicitudesPage /> },
      { path: "/docente/historial", element: <DocenteHistorialPage /> },
      { path: "/docente/devoluciones", element: <DocenteDevolucionesPage /> },

      // ═══════════════════════════════════════════
      // 8. ASISTENTE IA
      // ═══════════════════════════════════════════
      { path: "/ia/consulta", element: <ConsultaPage /> },
      { path: "/ia/protocolos", element: <ProtocolosPage /> },
      { path: "/ia/lectura", element: <ReglamentoPage /> },
      { path: "/ia/normativa", element: <NormativaPage /> },
      { path: "/ia/resumen", element: <ResumenGeneradorPage /> },
      { path: "/ia/informe", element: <OrientacionInformesGenerarPage /> },

      // ═══════════════════════════════════════════
      // 9. ADMINISTRACIÓN
      // ═══════════════════════════════════════════
      { path: "/admin", element: <AdminPage /> },
      { path: "/admin/usuarios", element: <AdminUsuariosPage /> },
      { path: "/admin/documentos", element: <AdminDocumentosPage /> },
      { path: "/admin/permisos", element: <AdminPermisosPage /> },
      { path: "/admin/configuracion", element: <AdminConfiguracionPage /> },
      { path: "/admin/auditoria", element: <AdminReportesPage /> },
      { path: "/admin/historial", element: <AdminHistorialPage /> },

      // ═══════════════════════════════════════════
      // LEGACY ROUTES (backward compat)
      // ═══════════════════════════════════════════
      { path: "/dashboard", element: <ResumenPage /> },
      { path: "/dashboard/alertas", element: <AlertasPage /> },
      { path: "/dashboard/calendario", element: <CalendarioPage /> },
      { path: "/casos", element: <CasosPage /> },
      { path: "/casos/nuevo", element: <CasoNuevoPage /> },
      { path: "/casos/kanban", element: <CasosKanbanPage /> },
      { path: "/casos/judicializados", element: <CasosJudicializadosPage /> },
      { path: "/casos/:caseId", element: <CasoDetallePage /> },
      { path: "/estudiantes", element: <EstudiantesPage /> },
      { path: "/estudiantes/:studentId", element: <EstudianteDetallePage /> },
      { path: "/intervenciones/nueva", element: <IntervencionNuevaPage /> },
      { path: "/intervenciones/entrevistas", element: <IntervencionEntrevistasPage /> },
      { path: "/intervenciones/derivaciones", element: <IntervencionDerivacionesPage /> },
      { path: "/intervenciones/seguimientos", element: <IntervencionSeguimientosPage /> },
      { path: "/intervenciones/evidencias", element: <IntervencionEvidenciasPage /> },
      { path: "/orientacion/informes/pendientes", element: <OrientacionInformesPage /> },
      { path: "/orientacion/informes/enviados", element: <OrientacionInformesEnviadosPage /> },
      { path: "/orientacion/informes/generar", element: <OrientacionInformesGenerarPage /> },
      { path: "/consulta", element: <ConsultaPage /> },
      { path: "/consulta/historial", element: <ConsultaHistorialPage /> },
      { path: "/consulta/protocolos", element: <ProtocolosPage /> },
      { path: "/reglamento", element: <ReglamentoPage /> },
      { path: "/normativa", element: <NormativaPage /> },
      { path: "/admin/reportes", element: <AdminReportesPage /> },
      { path: "/saas/tenants", element: <SaasTenantsPage /> },
      { path: "/saas/normativa", element: <SaasNormativaPage /> },
    ],
  },

  { path: "*", element: <NotFound /> },
];

export default routes;